import script from "./BanOfficerForClientView.vue?vue&type=script&setup=true&lang=js"
export * from "./BanOfficerForClientView.vue?vue&type=script&setup=true&lang=js"

import "./BanOfficerForClientView.vue?vue&type=style&index=0&id=8a330062&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a330062"]])

export default __exports__